<template>
   <span :class="`gts-info-badge gts-info-badge__${badgeClassName} ${modifier ? modifier : ''}`">{{ badgeText }}</span>
</template>

<script>
export default {
   name: "UIInfoBadge",
   props: {
      className: { type: String },
      text: { type: String },
      modifier: { type: String },
   },
   data() {
      return {
         badgeClassName: this.className,
         badgeText: this.text,
         badgeModifier: this.modifier,
      };
   },
   watch: {
      text: function (newValue) {
         var self = this;
         self.badgeText = newValue;
      },
   },
};
</script>

<style lang="scss" scoped>
html body .gts-info-badge {
   padding: 0.125rem 0.5rem;
   height: 19px;
   background-color: transparent;
   border: 1px solid;
   border-radius: 3px;
   color: black;
   font-size: var(--small);
   font-weight: var(--bold);
   cursor: default;
   white-space: nowrap;

   &__default {
      //background-color: var(--gray-50);
      background-color: var(--gray-0);
      border-color: var(--gray-300);
      color: var(--gray-700);
   }

   &__EHtlRefundType {
      &.--nonrefundable {
         background-color: var(--red-500);
         border-radius: 0.25rem;
         font-weight: 700;
         //color: var(--gray-50);
         color: var(--gray-0);
      }
      &.--refundable {
         background-color: var(--teal-0);
         border-radius: 0.25rem;
         font-weight: 700;
         border-color: var(--cyan-500);
         color: var(--cyan-500);
      }
   }

   &__HtlProviderInfo {
      border-radius: 0.25rem;
      opacity: 1;
      text-align: center;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 13px;
      height: 21px;
      box-sizing: content-box;
      padding: 0.125rem 0.35rem;

      &.--direct {
         background: var(--accent-primary-lighter);
         border: 1px solid var(--primary);
         color: var(--primary);
      }
      &.--direct-recommended {
         background: var(--primary);
         border: 1px solid var(--primary);
         //color: var(--gray-50);
         color: var(--gray-0);
      }
      &.--provider {
         background: var(--orange-400-light) er;
         border: 1px solid var(--orange-400);
         color: var(--orange-400);
      }
   }
   &__HotelStatus {
      border-radius: 0.25rem;
      opacity: 1;
      text-align: center;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 13px;
      height: 21px;
      box-sizing: content-box;
      padding: 0.125rem 0.35rem;
      &.--closed {
         background: var(--red-600-alpha-90);
         border-radius: 3px;
         color: var(--red-600);
      }
   }
}
</style>
